import { render, staticRenderFns } from "./noMore.vue?vue&type=template&id=4bcd83f4&scoped=true&"
import script from "./noMore.vue?vue&type=script&lang=js&"
export * from "./noMore.vue?vue&type=script&lang=js&"
import style0 from "./noMore.vue?vue&type=style&index=0&id=4bcd83f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd83f4",
  null
  
)

component.options.__file = "noMore.vue"
export default component.exports